import { Injectable } from '@angular/core';
import { PropertyFilter } from '@app/core/model/propertyFilter';

@Injectable({
  providedIn: 'root',
})
export class FilterService {
  constructor() {}

  public setFiltersByTable(tableLabel: string, filterValues: any): void {
    localStorage.setItem(tableLabel, JSON.stringify(filterValues));
  }

  public getFiltersByTable(tableLabel: string): any {
    return JSON.parse(localStorage.getItem(tableLabel));
  }

  public updateRows<T>(
    rows: T[],
    filters: PropertyFilter[],
    filterValues: any
  ): T[] {
    // For all filters with a value
    for (const filterName of Object.keys(filterValues).filter(
      key => filterValues[key]
    )) {
      // filter on each rows

      rows = rows.filter(
        // Apply the filtering function corresponding to the filter name
        row =>
          filters
            .find(f => f.name === filterName)
            .filteringFunction(row, filterValues[filterName])
      );
    }

    return rows;
  }
}
